import publicKeysCacheAtomDefinition from './atoms.js';
import publicKeyProviderModuleDefinition from './module.js';
import publicKeyProviderPluginDefinition from './plugin.js';
const publicKeyProvider = () => {
    return {
        id: 'publicKeyProvider',
        definitions: [
            { definition: publicKeyProviderModuleDefinition },
            { definition: publicKeyProviderPluginDefinition },
            {
                definition: publicKeysCacheAtomDefinition,
                storage: { namespace: 'publicKeyProvider' },
            },
        ],
    };
};
export default publicKeyProvider;
